export const TM_IAD_ALERTS_DETAILS = 'TM_IAD_ALERTS_DETAILS';
export const FRAUD_IAD_ALERTS_DETAILS = 'FRAUD_IAD_ALERTS_DETAILS';

export const ALERT_TOP_PANEL_DETAIL_GS_QUERY = {
  widgetGroupId: 'TM_IAD_ALERT_DETAILS_TOP_PANEL_GROUP',
  widgetId: 'TM_IAD_ALERT_BASIC_DETAILS'
};

export const FRAUD_ALERT_TOP_PANEL_DETAIL_GS_QUERY = {
  widgetGroupId: 'FRAUD_IAD_ALERT_DETAILS_TOP_PANEL_GROUP',
  widgetId: 'FRAUD_IAD_ALERT_BASIC_DETAILS'
};

export const ALERT_PARTY_IDENTITY_GS_QUERY = {
  individual: {
    widgetGroupId: 'TM_IAD_CUSTOMER_DETAILS_GROUP',
    widgetId: 'TM_IAD_CUSTOMER_PROFILE_WIDGET_I'
  },
  corporate: {
    widgetGroupId: 'TM_IAD_CUSTOMER_DETAILS_GROUP',
    widgetId: 'TM_IAD_CUSTOMER_PROFILE_WIDGET_C'
  }
};

export const FRAUD_ALERT_PARTY_IDENTITY_GS_QUERY = {
  individual: {
    widgetGroupId: 'FRAUD_IAD_CUSTOMER_DETAILS_GROUP',
    widgetId: 'FRAUD_IAD_CUSTOMER_PROFILE_WIDGET_I'
  },
  corporate: {
    widgetGroupId: 'FRAUD_IAD_CUSTOMER_DETAILS_GROUP',
    widgetId: 'FRAUD_IAD_CUSTOMER_PROFILE_WIDGET_C'
  }
};

export const TRANSACTION_DETAILS_GS_QUERY = {
  widgetGroupId: 'TM_IAD_TRANSACTION_DETAILS_GROUP',
  widgetId: 'TM_IAD_TRANSACTION_DETAILS_WIDGET'
};

export const FRAUD_TRANSACTION_DETAILS_GS_QUERY = {
  widgetGroupId: 'FRAUD_IAD_TRANSACTION_DETAILS_GROUP',
  widgetId: 'FRAUD_IAD_TRANSACTION_DETAILS_WIDGET'
};

export const ALERT_ASSOC_CUSTOMERS_GS_QUERY = {
  widgetGroupId: 'TM_IAD_CUSTOMER_DETAILS_GROUP',
  widgetId: 'TM_IAD_ASSOCIATED_CUSTOMER_WIDGET'
};

export const FRAUD_ALERT_ASSOC_CUSTOMERS_GS_QUERY = {
  widgetGroupId: 'FRAUD_IAD_CUSTOMER_DETAILS_GROUP',
  widgetId: 'FRAUD_IAD_ASSOCIATED_CUSTOMER_WIDGET'
};

export const ALERT_DETAILS_GS_QUERY = {
  widgetGroupId: 'TM_IAD_ALERT_DETAILS_GROUP',
  widgetId: 'TM_IAD_ALERT_DETAILS_WIDGET'
};

export const FRAUD_ALERT_DETAILS_GS_QUERY = {
  widgetGroupId: 'FRAUD_IAD_ALERT_DETAILS_GROUP',
  widgetId: 'FRAUD_IAD_ALERT_DETAILS_WIDGET'
};

export const LANDING_FROM = '';
export const RETURN_TO_PATH = '';
export const LANDED_IN = 'Alert Analysis';
